import {TitleBroadcastService} from '../../../services/title-broadcast.service';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {ActivatedRoute, Router} from '@angular/router';
import {ReplaySubject, Subject} from 'rxjs';
import {User} from '../../../dto/user';
import {TrackingLocation} from '../../../dto/tracking-location';
import swal from 'sweetalert2';
import {FormControl} from '@angular/forms';
import {takeUntil} from 'rxjs/internal/operators';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {MatPaginator, MatSelectChange, MatSort, MatTabChangeEvent} from '@angular/material';
import {Endpoints} from '../../../config/endpoints';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import {UserTimeline} from '../../../dto/user-timeline';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {DatePipe} from '@angular/common';
import {MarketFilter} from '../../../config/market-filter';

@Component({
    selector: 'app-location-list',
    templateUrl: './location-list.component.html',
    styleUrls: ['./location-list.component.scss']
})
export class LocationListComponent implements OnInit, AfterViewInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    locationList: TrackingLocation[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    selectedTab = 'map';
    dataSource: BaseDatasourceService<UserTimeline>;
    displayedColumns = ['SN', 'From', 'To', 'Duration', 'Address', 'Distance', 'Interval'];

    filters = {
        'UserId': null,
        'Date': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        'FromDateTime': moment().format(SERVER_DATE_FORMAT_WITH_TIME),
        'ToDateTime': moment().format(SERVER_DATE_FORMAT_WITH_TIME),
        'MarketIdList': null,

    };

    userType = 'ORGANIZATION_USER';
    timelineList: UserTimeline[] = [];

    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];

    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null};
    datePipe = new DatePipe('en-US');
    isCalenderOpen = false;
    @ViewChild(DaterangepickerDirective, {static: true}) dateRangePicker: DaterangepickerDirective;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    private _unsubscribeAll: Subject<any>;
    private isSelected: boolean;
    private isSelected1: boolean;
    private filename: string;
    private filetype: string;


    showMarketFilters = [];
    title = 'web_';

    marketHierarchyLength = 0;
    marketIndex = 0;
    marketLoading = false;
    marketLevelId = null;

    filterTitle = '_webFilter';
    saveFilterTitle = '_webFilterSave';
    showPreferences = false;
    showFilters = false;
    userRank: number;

    constructor(private router: Router, private service: BaseService, private auth: AuthService, private market: MarketFilter, private titleBroadcastService: TitleBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Tracking');
        this.loggedUser = auth.user;
        this.market.prepareUserMarket();
        this.marketLevels = market.marketLevels;
        this.marketLevels.forEach((pMarketLevels, index) => {
            this.showMarketFilters.push(true);
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = market.userRank;
        this.selectedMarket = market.selectedMarket;

        this.filterTitle += this.loggedUser.Id + '_marketWiseAttendedAbsentCount';
        this.saveFilterTitle += this.loggedUser.Id + '_marketWiseAttendedAbsentCount';

        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');

    }

    ngOnInit(): void {
        this.service.getUserList({
            ResponseFields: 'Id,Code,Name,Active',
            UserType: this.userType
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });

        this._getUserList();
        this.userFilter.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }
            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }

            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this.dataSource = new BaseDatasourceService<UserTimeline>(this.service);
        this.getFilters();
        this._getPreferredFilters();
    }

    ngAfterViewInit(): void {
    }

    setDateRange(event): void {
        const eventDate = moment(event.value);
        eventDate.set('hour', 0);
        eventDate.set('minute', 0);
        eventDate.set('second', 0);
        this.filters.FromDateTime = moment(eventDate).format(SERVER_DATE_FORMAT_WITH_TIME);
        eventDate.set('hour', 23);
        eventDate.set('minute', 59);
        eventDate.set('second', 59);
        this.filters.ToDateTime = moment(eventDate).format(SERVER_DATE_FORMAT_WITH_TIME);
        this.filters.Date = moment(eventDate).format(SERVER_DATE_FORMAT_WITHOUT_TIME);
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseFields: 'Id,Code,Name,Active',
            UserType: 'ORGANIZATION_USER',
            MarketIdList: marketIdList,
            PageNumber: 0,
            RecordsPerPage: 50,
            SearchKey: search
        }).subscribe(pUsers => {
            this.userList = pUsers;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    getLocationList(): void {
        if (!this.filters.UserId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }
        this.filters.MarketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.MarketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }
        this.loadingData = true;
        this.service.postData(Endpoints.user_timeline, this.filters).subscribe(locationList => {
            this.loadingData = false;
            if (locationList['Data']['content'].length > 0) {
                this.lat = locationList['Data']['content'][0].Lat;
                this.lng = locationList['Data']['content'][0].Lon;
            }
            this.locationList = locationList['Data']['content'];
        }, error => {
            this.loadingData = false;
        });
    }

    getFilters(): void {
        const tempMarketFilters = [];
        this.marketLevels.forEach(pMarketLevel => {
            if (localStorage.getItem(this.filterTitle + pMarketLevel.Name) != null) {
                tempMarketFilters.push(localStorage.getItem(this.filterTitle + pMarketLevel.Name) == 'true');
            }
        });
        if (tempMarketFilters.length > 0) {
            this.showMarketFilters = tempMarketFilters;
        }


    }

    setFilters(): void {
        this.marketLevels.forEach((pMarketLevel, index) => {
            localStorage.setItem(this.filterTitle + pMarketLevel.Name, this.showMarketFilters[index] ? 'true' : 'false');
        });

    }

    _getPreferredFilters(isDefault?: boolean): void {
        let marketIndex = null;
        if (localStorage.getItem(this.saveFilterTitle + 'Market')) {
            this.selectedMarket = JSON.parse(localStorage.getItem(this.saveFilterTitle + 'Market'));
        }
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIndex = i;
                break;
            }
        }

        if (marketIndex) {
            for (let i = 1; i < this.selectedMarket.length; i++) {
                if (this.selectedMarket[i]) {
                    const marketLevelId = this.selectedMarket[i].MarketLevel.Id;
                    let marketId;
                    if (i == 1 || this.selectedMarket[i].MarketLevel.Rank <= this.userRank) {
                        marketId = null;
                    } else {
                        marketId = this.selectedMarket[i - 1].Id;

                    }
                    this.service.getMarketMiniList(marketLevelId, marketId).subscribe(pResponse => {
                        this.markets[this.selectedMarket[i].MarketLevel.Rank] = pResponse;
                        this.filteredMarketList[this.selectedMarket[i].MarketLevel.Rank - 1].next(this.markets[this.selectedMarket[i].MarketLevel.Rank].slice());
                    });
                }

            }
        } else {
            this.filterMarkets();
        }

        if (this.filters.UserId) {
            this.getLocationList();
        }
    }

    resetParameters(): void {

        for (let i = 0; i < this.selectedMarket.length; i++) {
            if (this.userRank) {
                if (this.selectedMarket[i] &&
                    this.selectedMarket[i].MarketLevel.Rank > this.userRank) {
                    this.selectedMarket[i] = null;
                }
            } else {
                if (this.selectedMarket[i]) {
                    this.selectedMarket[i] = null;
                }
            }
        }

    }

    filterMarkets(): void {
        this.marketLevels.forEach((pMarketLevel, index) => {
            this.service.getMarketMiniList(pMarketLevel.Id).subscribe(pResponse => {
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        const selectedMarkets = [];
        this.marketLevels.forEach(pMarketLevel => {
            selectedMarkets[pMarketLevel.Rank] = null;
        });
        let rank = 0;
        if (pEvent.value) {
            this.service.getMarketDetails(pEvent.value.Id).subscribe(pMarket => {
                if (pMarket.ParentList) {
                    for (let i = pMarket.ParentList.length - 1; i >= 0; i--) {
                        selectedMarkets[pMarket.ParentList[i].MarketLevel.Rank] = pMarket.ParentList[i];
                        rank = pMarket.ParentList[i].MarketLevel.Rank;
                    }
                    selectedMarkets[rank + 1] = pMarket;
                    this.selectedMarket = selectedMarkets;
                } else {
                    for (let i = 0; i < selectedMarkets.length; i++) {
                        if (pMarket.MarketLevel.Rank == i) {
                            selectedMarkets[i] = pMarket;
                        }
                    }
                    this.selectedMarket = selectedMarkets;
                }
            });
        } else {
            for (let i = this.marketLevelId; i <= this.marketLevels.length; i++) {
                this.selectedMarket[i] = null;
            }
            if (this.userRank > 1) {
                let selectedMarket = new Market();
                for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
                    if (this.selectedMarket[i]) {
                        selectedMarket = this.selectedMarket[i];
                        break;
                    }
                }
                if (selectedMarket.MarketLevel) {
                    if (selectedMarket.MarketLevel.Rank < this.userRank) {
                        for (let i = 0; i < this.selectedMarket.length; i++) {
                            this.selectedMarket[i] = null;
                        }
                    }
                }
            }
        }
    }

    getMarketLevel(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        const marketLevelId = marketLevel.Id;
        this.marketLevelId = marketLevel.Rank;
        let marketId = null;
        let market = new Market();

        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketId = this.selectedMarket[i].Id;
                market = this.selectedMarket[i];
                break;
            }
        }

        if (marketId && marketLevelId != market.MarketLevel.Id && marketLevel.Rank > market.MarketLevel.Rank) {
            this.service.getMarketMiniList(marketLevelId, marketId).subscribe(pResponse => {
                this.markets[this.marketIndex] = pResponse;
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
            });
        }

    }

    switchTabs(): void {
        if (this.showPreferences) {
            this.showPreferences = false;
            this.showFilters = true;
        } else {
            this.showPreferences = true;
            this.showFilters = false;
        }
    }

    openFilterModal(pString: string): void {
        if (pString == 'filter') {
            this.showFilters = true;
            this.showPreferences = false;
        }
        if (pString == 'preference') {
            this.showPreferences = true;
            this.showFilters = false;
        }
        const modal = document.getElementById('filterModal');
        modal.style.display = 'block';
    }

    closeFilterModal(isPreference?: boolean): void {
        const modal = document.getElementById('filterModal');
        if (isPreference) {
            this.setFilters();
        }
        modal.style.display = 'none';
    }


    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.Id === pMarket2.Id;
    }

    compareById(pData1, pData2): boolean {
        return pData1 && pData2 && pData1 == pData2;
    }


    dateChangeListener(pEvent: any): void {
        this.filters.Date = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    tabChangeListener(pEvent: MatTabChangeEvent): void {
        if (pEvent.index == 0) {
            this.selectedTab = 'map';
            if (this.filters.UserId) {
                this.getLocationList();
            }
        } else {
            this.selectedTab = 'timeline';
            if (this.filters.UserId) {
                this.reloadDatatable();
            }

        }
    }

    reloadDatatable(): void {
        if (!this.filters.UserId) {
            swal('Wrong Input', 'Please select a user', 'warning');
            return;
        }
        this.dataSource.fetchRemoteData(Endpoints.user_timeline, this.filters);

    }


}
